<template>
  <div class="page-content">
    <el-row class="sign-manage-title search-title common-table-top">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">开放平台配置</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
      </el-col>
    </el-row>
    <el-row class="box-content">
      <div class="box-content-div">
        <!-- 有配置，展示信息 -->
        <div style="padding:20px 0" v-if="edit === false && setting !== null">
          <el-alert
            title="请将以下信息填写至微信开放平台"
            type="success"
            :closable="false">
          </el-alert>
          <table>
            <tr><th>授权登录相关</th><td></td></tr>
            <tr><td>授权发起页域名</td><td>{{apiHost}}</td></tr>
            <tr><td>授权事件接收URL</td><td>http://{{apiHost}}/wechat/ez_open_platform/wxcallback.html</td></tr>
            <tr><th>授权后实现业务</th><td></td></tr>
            <tr><td>消息校验Token</td><td>{{setting.token}}</td></tr>
            <tr><td>消息加解密Key</td><td>{{setting.key}}</td></tr>
            <tr><td>消息与事件接收URL</td><td>http://{{apiHost}}/wechat/easy_index/index/appid/$APPID$.html</td></tr>
            <tr><td>公众号开发域名</td><td>{{apiHost}}</td></tr>
            <tr><td>小程序服务器域名</td><td>{{apiHost}}</td></tr>
            <tr><td>小程序业务域名</td><td>{{apiHost}}</td></tr>
            <tr><td>白名单IP地址列表</td><td>39.106.0.169;47.110.70.32;47.110.70.156;47.99.192.208;47.110.165.193;47.110.82.198</td></tr>
          </table>
          <el-button class="second-page-btn reply-btn-type" type="primary" style="float: none;margin-left: 0;"  @click="edit=true">编辑</el-button>

        </div>
        <!-- 无配置，填写appid和appsecret -->
        <el-form v-else :model="openForm" :rules="rules" ref="openForm" label-width="150px"  class="box-content-form">

          <el-alert
            title="请进入微信开放平台查看appid和appsecret，并在此填写"
            type="success"
            :closable="false"
            style="margin-bottom:20px">
          </el-alert>
          <el-form-item label="APPID:" prop='appid' style="margin-left: 220px">
            <el-input v-model="openForm.appid" placeholder="请输入APPID"></el-input>
          </el-form-item>
          <el-form-item label="APPSECRET:" prop='appsecret' style="margin-left: 220px">
            <el-input v-model="openForm.appsecret" placeholder="请输入APPSECRET"></el-input>
          </el-form-item>
          
          
          <el-form-item label="" style="text-align: left;width: 100%;">
            <el-button class="second-page-btn reply-btn-type" type="primary" style="float: none;margin-left: 218px;"  @click="save()">保存</el-button>
          </el-form-item>
        </el-form>
        
      </div>
    </el-row>
   
    
    
  </div>
</template>

<script>
import { API_HOST } from '@/api/local'
import { openPlatform, openPlatformSave } from '@/api/customer.js'
export default {
  name: 'ReplyKeyWordAdd',
  data () {
    return {
      openForm: {
        appid: '',
        appsecret: ''
      },
      edit: true,
      // 配置信息
      setting: null,
      rules: {
        appid: [
          { required: true, message: '请输入appid', trigger: 'blur' }
        ],
        appsecret: [
          { required: true, message: '请输入appsecret', trigger: 'blur' }
        ]
      },
      
    }
  },
  methods: {
    save() {
      this.$refs.openForm.validate((valid) => {
        if (valid) {
          openPlatformSave(this.openForm).then(res => {
            if(res.data.code === 0){
              this.getSetting()     
              _g.toastMsg('success', '配置成功')   
            }else{
              _g.toastMsg('error', res.data.error)
            }
          })
        } else {
          return false
        }
      })
      
    },
    getSetting(){
      openPlatform().then(res => {
        if(res.data.data !== null){
          this.openForm = {
            appid: res.data.data['appid'],
            appsecret: res.data.data['appsecret']
          }
          this.setting = res.data.data    
          this.edit = false            
        }
      })
    }
  },
  computed:{
    apiHost() {
      let url = new URL(API_HOST)
      return url.host
    }
  },
  created() {
    this.getSetting()
  }
}
</script>

<style scoped>
table{width:100%}
td,th{text-align: left;border-bottom: 1px solid #f4f4f4;padding:10px}
.green{
  color: green;
}
.red{
  color: red;
}
.add-btn{
  height: 30px;
  padding: 0 10px;
  border-radius: 20px;
  text-align: center;
  line-height: 30px;
  float: right;
  color: #fff;
  font-size: 14px;
  background: #4882ff;
  margin-top: 5px;
  cursor: pointer;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.box-content-div {
  width: 800px;
  margin: auto;
}
.box-content-form {
  margin-top: 10px;
  text-align: center;
}
.box-content-form .el-form-item {
  width: 300px;
}

.avatar-uploader {
  border: 1px #d9d9d9 dashed;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 178px;
  margin: 0 auto;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.Reply{
  height: 100px;
}
.Reply li{
  width: 130px;
  height: 130px;
  margin-right: 20px;
  border-radius: 5px;
  float: left;
  list-style: none;
  cursor: pointer;
  margin-bottom: 20px;
}
.Reply li i{
  font-size: 40px;
  margin: 20px 0 8px 0;
}
.Reply li span{
  display: block;
  font-size: 14px;
}
.Reply li:hover{
  color: #FF9B00;
}
.replyMarketing{
  position: relative;
  top: -20px;
  height: 292px;
  text-align: left;
  padding-left: 20px;
}
.page{
  position: absolute;
  bottom: -44px;
  right: 0;
}

.interest-image {
  display: inline-block;
  width: 148px;
  height: 148px;
  position: relative;
}
.opacity-div {
  width: 148px;
  height: 148px;
  position: relative;
}
.opacity-div:hover .back-div {
  opacity: 1 !important;
}
.back-div {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  height: 148px;
  width: 148px;
  top: 0px;
  left: 1px;
  opacity: 0;
  cursor: pointer;
  color: #fff;
  line-height: 148px;
}
.default-images {
  width: 148px;
}
.interest-uploader {
  width: 148px;
  height: 148px;
}
</style>
